import { SERVER_API_URL } from "../constants/constants";
import axios from "axios";

const getAuthConfig = () => {
  const token = localStorage.getItem("token");

  return {
    headers: { Authorization: `Bearer ${token}` },
  };
};

const getHelpAndSupportSettings = async () => {
  try {
    const url = `${SERVER_API_URL}/admin/app_settings`;
    const response = await axios.get(url, getAuthConfig());
    return response.data;
  } catch (error) {
    throw error;
  }
};

const updateHelpAndSupportSettings = async (settingsData) => {
  try {
    const url = `${SERVER_API_URL}/admin/app_settings`;
    const response = await axios.put(url, settingsData, getAuthConfig());
    return response.data;
  } catch (error) {
    throw error;
  }
};

export { getHelpAndSupportSettings, updateHelpAndSupportSettings };
